import { GridColumns, GridRenderCellParams } from '@mui/x-data-grid-premium';
import { useTranslation } from 'react-i18next';
import { filterOperators } from '../../../../constants';
import { baseCell } from '../cells/base-cell';
import { Link } from 'react-router-dom';

export const AccessoryColumns = (): GridColumns => {
  const translationPrefix = 'entities.accessor';
  const { t } = useTranslation();

  const columns = [
    {
      field: 'code',
      headerName: t(`global.code`),
      filterOperators,
      renderCell: (params: GridRenderCellParams) => {
        const accessor = params.row;
        return (
          <Link to={`${accessor.id}`}>
            <b className="text-secondary-500">{accessor.code}</b>
          </Link>
        );
      }
    },
    {
      field: 'description',
      headerName: t(`${translationPrefix}.description`),
      width: 250,
      filterOperators,
      renderCell: baseCell
    },
    {
      field: 'serial_number',
      headerName: t(`${translationPrefix}.serial_number`),
      width: 250,
      filterOperators,
      renderCell: baseCell
    },
    {
      field: 'equipment_code',
      headerName: t(`${translationPrefix}.equipment-code`),
      width: 250,
      filterOperators,
      renderCell: baseCell
    },
    {
      field: 'equipment_description',
      headerName: t(`${translationPrefix}.equipment-description`),
      width: 250,
      filterOperators,
      renderCell: baseCell
    },
    {
      field: 'supplier',
      headerName: t(`global.supplier`),
      width: 250,
      filterOperators,
      renderCell: baseCell
    },
    {
      field: 'warehouse_code',
      headerName: t(`global.warehouse`),
      width: 250,
      filterOperators,
      renderCell: baseCell
    }
  ];

  return columns;
};
